import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from './forms/LoginForm';
import ForgotPasswordForm from './forms/ForgotPasswordForm';
import ResetPasswordForm from './forms/ResetPasswordForm';

type AuthView = 'login' | 'forgot-password' | 'reset-password';

const AuthWrapper: React.FC = () => {
  const [currentView, setCurrentView] = useState<AuthView>('login');
  const { clearAuthState } = useAuth();

  const handleForgotPassword = () => {
    setCurrentView('forgot-password');
  };

  const handleBackToLogin = () => {
    // Clear auth state when going back to login to prevent auto-login
    clearAuthState();
    setCurrentView('login');
  };

  const handleResetSuccess = () => {
    // Clear auth state when going back to login after reset
    clearAuthState();
    setCurrentView('login');
  };

  const handleForgotSuccess = () => {
    setCurrentView('login');
  };

  // Check if we're on a reset password page (from email link)
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const hash = window.location.hash;
    
    // Check for Supabase auth parameters in URL hash
    const hashParams = new URLSearchParams(hash.substring(1));
    const type = urlParams.get('type') || hashParams.get('type');
    const accessToken = urlParams.get('access_token') || hashParams.get('access_token');
    const refreshToken = urlParams.get('refresh_token') || hashParams.get('refresh_token');

    if (type === 'recovery' && accessToken && refreshToken) {
      setCurrentView('reset-password');
    }
  }, []);

  switch (currentView) {
    case 'forgot-password':
      return (
        <ForgotPasswordForm
          onBackToLogin={handleBackToLogin}
          onSuccess={handleForgotSuccess}
        />
      );
    case 'reset-password':
      return (
        <ResetPasswordForm
          onSuccess={handleResetSuccess}
        />
      );
    case 'login':
    default:
      return (
        <LoginForm
          onForgotPassword={handleForgotPassword}
        />
      );
  }
};

export default AuthWrapper;
